<script setup>
// Botão "Ligar pelo PABX" no header da conversa (linha SIP da caixa, ao lado do
// BCVOZ). Disca pelo mesmo softphone do AstraCall: a ligação sai pelo RAMAL de
// quem clicou (o conector casa pelo e-mail) e aparece no dock global.
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useAstraCalls } from 'dashboard/composables/useAstraCalls';

const props = defineProps({
  inbox: { type: Object, default: () => ({}) },
  chat: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const getters = useStoreGetters();
const { state, ensureInit, dial, sessionForInbox } = useAstraCalls();

onMounted(() => {
  const accountId = getters.getCurrentAccountId.value;
  if (accountId) ensureInit(accountId);
});

const session = computed(() =>
  state.enabled ? sessionForInbox(props.inbox?.id, 'sip') : null
);
const phone = computed(() =>
  String(props.chat?.meta?.sender?.phone_number || '').replace(/\D/g, '')
);

const call = async () => {
  if (!phone.value) {
    useAlert(t('CONVERSATION.SIP_PABX.NO_PHONE'));
    return;
  }
  try {
    await dial({
      sid: session.value.sid,
      phone: phone.value,
      conversationId: props.chat?.id,
      contactName: props.chat?.meta?.sender?.name,
    });
  } catch (e) {
    useAlert(e?.message || t('CONVERSATION.SIP_PABX.ERROR'));
  }
};
</script>

<template>
  <button
    v-if="session"
    v-tooltip.bottom="t('CONVERSATION.SIP_PABX.CALL')"
    class="inline-flex items-center justify-center rounded-lg size-8 text-n-slate-11 hover:bg-n-alpha-1 hover:text-n-teal-11"
    @click="call"
  >
    <span class="i-lucide-phone-outgoing size-5" />
  </button>
</template>
